import { makeStyles } from '@material-ui/core'

export const compensationPopupColors = {
  aqua100: '#A8DDD6',
  aqua75: '#CAEDE7',
  aqua50: '#EDF8F7',

  grey300: '#E0E0E0',
  grey200: '#EEEEEE',
  grey100: '#F5F5F5',

  orange: '#E86E30',
}

export const useCompensationPopupStyles = makeStyles({
  smallSpacingLabel: {
    // we need 10px padding, also accordion label has 3px transparent border
    paddingTop: '7px !important',
    paddingBottom: '7px !important',
  },
  labelAsAccordion: {
    // padding 8px from accordion label and 3px border
    paddingRight: 11,
    paddingLeft: 16,
    paddingTop: 7,
    paddingBottom: 7,
  },
  withRightSpace: {
    marginRight: 16,
  },
  accordionLabel: {
    padding: '16px 8px',
    borderRadius: '8px',
    border: '3px solid transparent',
    fontFamily: 'Lato',
  },
  // TODO refactor payout label component and create accordion labels components for 1,2,3 levels
  firstLevelLabel: {
    fontSize: '17px !important',
  },
  smallAccordionIcon: {
    '& > svg': {
      width: 19,
    },
  },
  leftAlignedToAccordionLg: {
    paddingLeft: '35px',
  },
  leftAlignedToAccordionSm: {
    paddingLeft: '30px',
  },
  // aqua labels
  activeAqua75Label: {
    backgroundColor: compensationPopupColors.aqua75,
    borderColor: 'white',
    '&:hover': {
      backgroundColor: compensationPopupColors.aqua100,
    },
  },
  activeAqua100Label: {
    backgroundColor: compensationPopupColors.aqua100,
    borderColor: compensationPopupColors.aqua50,
    '&:hover': {
      backgroundColor: compensationPopupColors.aqua75,
    },
  },
  // grey labels
  activeGrey300Label: {
    backgroundColor: compensationPopupColors.grey300,
    borderColor: compensationPopupColors.grey100,
    '&:hover': {
      backgroundColor: compensationPopupColors.grey200,
    },
  },
  activeGrey200Label: {
    backgroundColor: compensationPopupColors.grey200,
    borderColor: 'white',
    '&:hover': {
      backgroundColor: compensationPopupColors.grey300,
    },
  },
  // content
  activeWhiteContent: {
    backgroundColor: 'white',
    borderRadius: '8px',
  },
  activeAqua50Content: {
    backgroundColor: compensationPopupColors.aqua50,
    borderRadius: '8px',
  },
  activeGrey100Content: {
    backgroundColor: compensationPopupColors.grey100,
    borderRadius: '8px',
  },
  whiteLabelWithAquaHover: {
    '&:hover': {
      backgroundColor: compensationPopupColors.aqua75,
    },
  },
  aqua100Label: {
    '&:hover': {
      backgroundColor: compensationPopupColors.aqua75,
    },
  },
  grey300Label: {
    '&:hover': {
      backgroundColor: compensationPopupColors.grey300,
    },
  },
  whiteLabelWithGreyHover: {
    '&:hover': {
      backgroundColor: compensationPopupColors.grey200,
    },
  },
})
